module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "time-col"
  }, [_c('abbr', {
    staticClass: "timeago",
    attrs: {
      "title": _vm.created_at
    }
  }, [_vm._v(_vm._s(_vm.ymd))])]), _vm._v(" "), _c('td', {
    staticClass: "email-col"
  }, [_c('a', {
    attrs: {
      "href": _vm.requery(_vm.email)
    }
  }, [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('td', {
    staticClass: "org-col"
  }, [_c('a', {
    attrs: {
      "href": _vm.requery(_vm.organization)
    }
  }, [_vm._v(_vm._s(_vm.organization))])]), _vm._v(" "), _c('td', {
    staticClass: "action-col"
  }, [_c('a', {
    attrs: {
      "href": _vm.requery(_vm.request.replace('#', ' '))
    }
  }, [_vm._v(_vm._s(_vm.request))])]), _vm._v(" "), _c('td', {
    staticClass: "link-col"
  }, [(_vm.request_url) ? _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "title": _vm.request_url,
      "href": _vm.request_url
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.requery(_vm.request_url)
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("find_in_page")])])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "details-col"
  }, [_c('a', {
    attrs: {
      "href": _vm.activity.url
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("pageview")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0583fc07","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/activity_row.vue
// module id = 11
// module chunks = 0 1 3